import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ImageIcon } from 'assets/icons';
import { theme } from 'styles';
import { Box, CenterFlex, Icon, MarginBox, Text } from 'UI';

const EmptyBox = styled(Box)`
  aspect-ratio: 5/1;
  border-radius: 15px;

  :hover {
    cursor: pointer;
  }
`;

const PromotionImageEmpty = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation();
  return (
    <EmptyBox width={'100%'} background={theme.color.grey85} onClick={onClick} data-cy={'promotion-image-empty'}>
      <CenterFlex direction={'column'}>
        <Icon IconComponent={ImageIcon} size={36} />
        <MarginBox mt={15} />
        <Text type="heading4">{t('backoffice.promotion.image.select_picture', 'Select picture')}</Text>
      </CenterFlex>
    </EmptyBox>
  );
};

export default PromotionImageEmpty;
